import { Emitter } from '@wonderlandengine/api';
import { AbstractGlobalProvider } from './provider.js';
class UserProviderManager extends AbstractGlobalProvider {
    name = 'uber-user-provider';
    onAuthChange = new Emitter();
    providers = [];
    registerProvider(p) {
        this.providers.push(p);
        /* Forward onAuthChange events */
        if (p.onAuthChange)
            p.onAuthChange.add(this.onAuthChange.notify.bind(this.onAuthChange));
    }
    get isLoggedIn() {
        for (let u of this.providers)
            if (u.isLoggedIn)
                return true;
        return false;
    }
    get user() {
        for (let u of this.providers)
            if (u.isLoggedIn)
                return u.user;
        return null;
    }
    requestLogin() {
        for (let u of this.providers)
            if (!u.isLoggedIn)
                return u.requestLogin();
        return Promise.reject();
    }
}
export const user = new UserProviderManager();
